import style from "./liveIntegrationTraitMenuItem.module.css";
import { DropdownButton } from "../../toolbar-buttons";
import toolbar_styles from "../../elements-toolbar.module.css";
import classNames from "classnames";
import { LiveIntegrationValue } from "./utils";
import { LiveIntegrationPicker } from "./liveIntegrationPicker";
import { LiveIconSVG } from "frontend/icons/live-icon";

export default function LiveIntegrationTraitMenuItem({
  value,
  onChange,
  documentId,
}: {
  value: LiveIntegrationValue;
  onChange: (newValue: LiveIntegrationValue) => void;
  documentId?: string;
}) {
  const { integrationId, filters } = value;
  return (
    <DropdownButton
      data-testid="LiveIntegrationProps"
      renderPopup={() => (
        <div className={classNames(toolbar_styles.miniToolbarLayout)}>
          <LiveIntegrationPicker
            integrationId={integrationId}
            filters={filters}
            documentId={documentId}
            onChange={onChange}
          />
        </div>
      )}
      arrowSize={12}
      className={toolbar_styles.miniToolbarPopup}
    >
      <div className={style.menuTitle}>
        <LiveIconSVG size={14} color={integrationId ? "#00B875" : "white"} />
        <span className={classNames(style.liveTitle, { [style.live]: !!integrationId })}>Live view</span>
      </div>
    </DropdownButton>
  );
}
